import dataModel from '../../models/DataModel.js';
import projectTemplatesService from '../../services/projectTemplatesService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export default class ProjectTypesCollection extends AOCollection {
  constructor(name, searchString, userId, companyId, marketId, subKey, recordDescriptor, published) {
    super({
      name: name,
      collectionType: ReduxConstants.PROJECT_TYPE,
      searchString,
      userId,
      companyId, 
      subKey,
      recordDescriptor,
    });
    this.marketId = marketId;
    this.published = published;
    this.handleOffLineFetch = this.handleOffLineFetch.bind(this);
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(name, searchString, userId, companyId, marketId, subKey, recordDescriptor, published) {
    if (!name) {
      name = ReduxConstants.PROJECT_TYPE;
    }
    const collection = new ProjectTypesCollection(name, searchString, userId, companyId, marketId, subKey, recordDescriptor, published);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getDefaultData(), collection.getCollectionType());
      collection.ids = collectionData.ids;
    }
    else {
      collection.ids = [];
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let collection = this.getDenormalizedCollection(options);
      return resolve(collection);
    });
  }

  async fetchCurrent(dummy, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = projectTemplatesService.getProjectTypesByCompany.bind(this, localStorage.current_company_id, this._searchString, this.marketId, options, this.published);

        let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
    
        return resolve(newCollection.project_types);
      });
    }
  }

  async processItemActionCable(updatedProjectType, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const projectTypesCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'newProjectType') {
        if (updatedProjectType) {
          projectTypesCollection.project_types.push(updatedProjectType);
          projectTypesCollection.project_types.sort((p1, p2) => {
            return p1.name < p2.name ? -1 : p1.name > p2.name ? 1 : 0;
          });
          projectTypesCollection.totalRecords = projectTypesCollection.project_types.length;
          projectTypesCollection.ids = this.normalizeCollection(projectTypesCollection.project_types, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), projectTypesCollection, this.getCollectionType());
          let projectTypes = this.getDenormalizedCollection({ recordDescriptor });
          return resolve(projectTypes.project_types);
        }
      }
      else if (acData.type == 'updateProjectType') {
        if (updatedProjectType) {
          let found = false;
          
          projectTypesCollection.project_types = projectTypesCollection.project_types.map(proj => {
            if (proj.id == updatedProjectType.id) {
              found = true;
              return updatedProjectType;
            }
            else {
              return proj;
            }
          });
          if (!found) {
            let addProject = false;
            if (this.getAllProjects) {
              addProject = true;
            }
            else {
              if (updatedProjectType.project_users &&
                updatedProjectType.project_users.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id;}).length > 0) {
                addProject = true;
              }
              else if (updatedProjectType.users &&
                updatedProjectType.users.filter(user => { return user.id == dataModel.usersDAO.currentUser.id;}).length > 0) {
                addProject = true;
              }
            }
            if (addProject) {
              projectTypesCollection.project_types.push(updatedProjectType);
              projectTypesCollection.totalRecords = projectTypesCollection.project_types.length;
            }
          }
          projectTypesCollection.ids = this.normalizeCollection(projectTypesCollection.project_types, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), projectTypesCollection, this.getCollectionType());
          let projectTypes = this.getDenormalizedCollection({ recordDescriptor });
          return resolve(projectTypes.project_types);
        }
      }
      else if (acData.type == 'deleteProject') {
        projectTypesCollection.project_types = projectTypesCollection.project_types.filter(proj => {
          if (proj.id != acData.project_id){
            return true;
          }
          else {
            return false;
          }
        });
        projectTypesCollection.totalRecords = projectTypesCollection.project_types.length;
        projectTypesCollection.ids = this.normalizeCollection(projectTypesCollection.project_types, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), projectTypesCollection, this.getCollectionType());
        let projectTypes = this.getDenormalizedCollection({ recordDescriptor });
        return resolve(projectTypes.project_types);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/dao/collections/ProjectTypesCollection.js